import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import PublicLayout from "./components/public/PublicLayout";
import Home from "./pages/public/Home";
import About from "./pages/public/About";
import MissionVision from "./pages/public/MissionVision";
import History from "./pages/public/History";
import Objectives from "./pages/public/Objectives";
import ExecutiveCommittee from "./pages/public/ExecutiveCommittee";
import PastPresidents from "./pages/public/PastPresidents";
import Members from "./pages/public/Members";
import BecomeMember from "./pages/public/BecomeMember";
import Announcements from "./pages/public/Announcements";
import AnnouncementDetail from "./pages/public/AnnouncementDetail";
import Events from "./pages/public/Events";
import EventDetail from "./pages/public/EventDetail";
import CmePrograms from "./pages/public/CmePrograms";
import Gallery from "./pages/public/Gallery";
import GalleryAlbum from "./pages/public/GalleryAlbum";
import Downloads from "./pages/public/Downloads";
import Contact from "./pages/public/Contact";
import Privacy from "./pages/public/Privacy";
import Terms from "./pages/public/Terms";
import NotFound from "./pages/public/NotFound";
import SearchResults from "./pages/public/SearchResults";

import Login from "./pages/admin/Login";
import AdminLayout from "./components/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import AnnouncementsAdmin from "./pages/admin/AnnouncementsAdmin";
import SliderAdmin from "./pages/admin/SliderAdmin";
import EventsAdmin from "./pages/admin/EventsAdmin";
import CommitteeAdmin from "./pages/admin/CommitteeAdmin";
import MembersAdmin from "./pages/admin/MembersAdmin";
import MediaLibraryAdmin from "./pages/admin/MediaLibraryAdmin";
import GalleryAdmin from "./pages/admin/GalleryAdmin";
import TestimonialsAdmin from "./pages/admin/TestimonialsAdmin";
import DownloadsAdmin from "./pages/admin/DownloadsAdmin";
import MessagesAdmin from "./pages/admin/MessagesAdmin";
import ApplicationsAdmin from "./pages/admin/ApplicationsAdmin";
import SettingsAdmin from "./pages/admin/SettingsAdmin";
import Profile from "./pages/admin/Profile";
import ScrollToTopButton from "./components/ui/ScrollToTopButton";

function AdminGuard({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-brand-muted">Loading…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/mission-vision" element={<MissionVision />} />
              <Route path="/history" element={<History />} />
              <Route path="/objectives" element={<Objectives />} />
              <Route path="/executive-committee" element={<ExecutiveCommittee />} />
              <Route path="/past-presidents" element={<PastPresidents />} />
              <Route path="/members" element={<Members />} />
              <Route path="/become-member" element={<BecomeMember />} />
              <Route path="/announcements" element={<Announcements />} />
              <Route path="/announcements/:slug" element={<AnnouncementDetail />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:slug" element={<EventDetail />} />
              <Route path="/cme-programs" element={<CmePrograms />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/gallery/:slug" element={<GalleryAlbum />} />
              <Route path="/downloads" element={<Downloads />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<AdminGuard><AdminLayout /></AdminGuard>}>
              <Route index element={<Dashboard />} />
              <Route path="slider" element={<SliderAdmin />} />
              <Route path="announcements" element={<AnnouncementsAdmin />} />
              <Route path="events" element={<EventsAdmin />} />
              <Route path="committee" element={<CommitteeAdmin />} />
              <Route path="members" element={<MembersAdmin />} />
              <Route path="media" element={<MediaLibraryAdmin />} />
              <Route path="gallery" element={<GalleryAdmin />} />
              <Route path="testimonials" element={<TestimonialsAdmin />} />
              <Route path="downloads" element={<DownloadsAdmin />} />
              <Route path="messages" element={<MessagesAdmin />} />
              <Route path="applications" element={<ApplicationsAdmin />} />
              <Route path="settings" element={<SettingsAdmin />} />
              <Route path="profile" element={<Profile />} />
            </Route>
          </Routes>
           <ScrollToTopButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
